import {enableProdMode} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import PackageJson from '../package.json';

fetch('/assets/config.json').then(async res => {

  const configuration = await res.json();

  console.debug('Loaded config json');
  console.info('Application Version:', PackageJson.version);

  if(configuration.production) {
    enableProdMode();
  } else {
    // Uncomment the two lines indicated below by inline comments.
    // They can help debugging streams that have properly been tagged.
    // But beware of the performance hit.  Pages with heavy use of streams (like the list components where the icon buttons show up if gui permission service deems it appropriate)
    // See: https://stackoverflow.com/a/54028997/475735
    // When running in this mode, pop open a dev console and run `rxSpy.show()` to see some info about any tagged subscriptions
    // We enable RXjs Spy on non production builds only
    // const spy = create();
    // We call show for two purposes:
    //  - first is to log to the console an empty snapshot so we can see that everything is working as expected,
    //  - then to suppress unused variable usage
    // spy.show();
    configuration.version = PackageJson.version;
  }
return bootstrapApplication(AppComponent, appConfig(configuration));
})
.catch(err => console.error(err));

